import router from '@/router'
import { DateTime } from 'luxon'
import lookups from '@/assets/json/clientLookups.json'
import client_config from '@/assets/json/client_config.json'
import useFormatDate from '@/composables/useFormatDate'
import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'

export default function () {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { formateDateFromDDMMYYYY } = useFormatDate()
  const birthday =
    formStore.form.values.dateOfBirth && formateDateFromDDMMYYYY(formStore.form.values.dateOfBirth)
  return {
    specialNewbornResidency: false,
    hideIdentificationInformation:
      globalStore.startedService.serviceConfig.hideIdentificationInformation,
    serviceTransactionId: router.currentRoute.value.params.serviceId,
    dateOfBirth:
      birthday &&
      DateTime.now().diff(birthday, 'years').years &&
      Math.floor(DateTime.now().diff(birthday, 'years').years),
    showCompanionNumber:
      lookups.companionNumberForVisa.includes(+router.currentRoute.value.params.serviceId) &&
      lookups.enableCompanionNumber &&
      globalStore.startedService.transactionId == 9,
    seaPortPassengerId: formStore.form.values.seaPortPassengerId,
    enablePassportUploader: client_config.enablePassportUploader
  }
}
